import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Cost } from '@/features/cost'

const costSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  filter: z.string().optional().catch(''),
  type: z.array(z.string()).optional().catch([]),
  status: z.array(z.string()).optional().catch([]),
  job: z.array(z.string()).optional().catch([]),
  model: z.array(z.string()).optional().catch([]),
  from: z.string().optional().catch(undefined),
  to: z.string().optional().catch(undefined),
  requests: z.string().optional().catch(undefined),
  inputTokens: z.string().optional().catch(undefined),
  outputTokens: z.string().optional().catch(undefined),
  cost: z.string().optional().catch(undefined),
})

export type CostSearchParams = z.infer<typeof costSearchSchema>

export const Route = createFileRoute('/_authenticated/admin/cost')({
  validateSearch: costSearchSchema,
  component: Cost,
})
